export const TENANT_WEBSITE_CARDS_RESET_STATE = 'TENANT_WEBSITE_CARDS_RESET_STATE';
export const TENANT_WEBSITE_CARDS_CURRENT_ITEM = 'TENANT_WEBSITE_CARDS_CURRENT_ITEM';

export const TENANT_WEBSITE_CARDS_REQUEST_LOADING = 'TENANT_WEBSITE_CARDS_REQUEST_LOADING';
export const TENANT_WEBSITE_CARDS_REQUEST_SUCCESS = 'TENANT_WEBSITE_CARDS_REQUEST_SUCCESS';
export const TENANT_WEBSITE_CARDS_REQUEST_FAILED = 'TENANT_WEBSITE_CARDS_REQUEST_FAILED';

export const TENANT_WEBSITE_CARDS_CURRENT_ACTION = 'TENANT_WEBSITE_CARDS_CURRENT_ACTION';
export const TENANT_WEBSITE_CARDS_RESET_ACTION = 'TENANT_WEBSITE_CARDS_RESET_ACTION';